import afreecaApi from '../../../../common/apis/afreecaApi';
import type { Clip } from '../../clipQueueSlice';
import type { ClipProvider } from '../providers';
class AfreecaClipProvider implements ClipProvider {
  name = 'afreeca-clip';

  getIdFromUrl(url: string): string | undefined {
    let uri: URL;
    try {
      uri = new URL(url);
    } catch {
      return undefined;
    }

    if (uri.hostname.endsWith('vod.afreecatv.com')) {
      const idStart = uri.pathname.lastIndexOf('/') + 1;
      const id = uri.pathname.slice(idStart).split('?')[0];

      if (!id) {
        return undefined;
      }

      return id;
    }

    return undefined;
  }

  async getClipById(id: string): Promise<Clip | undefined> {
    const clipInfo = await afreecaApi.getClip(id);

    return {
      id,
      title: clipInfo?.title ?? id,
      author: clipInfo?.author_name ?? 'afreeca',
      thumbnailUrl: clipInfo?.thumbnail_url,
      submitters: [],
      Platform: 'Afreeca',
    };
  }

  getUrl(id: string): string | undefined {
    return `https://vod.afreecatv.com/player/${id}`;
  }

  getEmbedUrl(id: string): string | undefined {
    return `https://vod.afreecatv.com/player/${id}/embed?showChat=false&autoPlay=true&mutePlay=false`;
  }

  async getAutoplayUrl(id: string): Promise<string | undefined> {
    return this.getUrl(id);
  }
}

const afreecaClipProvider = new AfreecaClipProvider();

export default afreecaClipProvider;
